module.exports = __webpack_public_path__ + "static/media/Saderat.3e9d13fc.svg";